export default __webpack_public_path__ + "static/media/Carrers.8ed1fc1d.jpg";